module.exports = __webpack_public_path__ + "img/ic_white_cal.4f68a37b.png";